import React from "react";
import { Button, CopyTextContainer, Dialog, Toast } from "@sscs/ui";
import DialogWarning from "../DialogWarning/DialogWarning";
import styles from "./generateAccessToken.module.scss";

type TokenGeneratedProps = {
  isOpen: boolean;
  onClose: () => void;
  generatedToken: string;
};

const TokenGeneratedContent = ({
  onClose,
  generatedToken,
}: Omit<TokenGeneratedProps, "isOpen">): React.JSX.Element => {
  const onCopyToClipboard = () => {
    Toast.show({
      title: "Access token copied to clipboard",
      type: "info",
    });
  };

  return (
    <>
      <Dialog.Header>
        <Dialog.Header.Title>
          Personal access token generated
        </Dialog.Header.Title>
      </Dialog.Header>
      <Dialog.Body>
        <Dialog.Section>
          <Dialog.Section.Content>
            <CopyTextContainer
              id="generated-access-token"
              name="generated-access-token"
              text={generatedToken}
              tooltipTitle="Click to copy the access token to your clipboard"
              onCopyToClipboard={onCopyToClipboard}
              multiline
              className={styles["copy-text-container"]}
            />
            <DialogWarning
              status="info"
              title="Important!"
              byline="Make sure you copy the token above now. We don’t store it and you will not be able to see it again."
            />
          </Dialog.Section.Content>
        </Dialog.Section>
      </Dialog.Body>
      <Dialog.Footer>
        <Dialog.Footer.Actions>
          <Button color="secondary" onClick={onClose}>
            Close
          </Button>
        </Dialog.Footer.Actions>
      </Dialog.Footer>
    </>
  );
};

// The token is shown once, so this dialog is not dismissible: passing no
// `onClose` keeps the backdrop, Escape and the header X from discarding it.
const TokenGenerated = ({
  isOpen,
  ...props
}: TokenGeneratedProps): React.JSX.Element => (
  <Dialog.Frame isOpen={isOpen}>
    <TokenGeneratedContent {...props} />
  </Dialog.Frame>
);

export default TokenGenerated;
